import { CompanyStructure } from "@wingspanhq/users";
import { SELECT_OPTIONS_BUSINESS_TYPE } from "../constants/member";

export const selectorTaxClassificationLabel = (value?: CompanyStructure) =>
  SELECT_OPTIONS_BUSINESS_TYPE.find(option => option.value === value)?.label ||
  "Sole proprietorship";
